import { makeRequest } from '../base/axios.ts'

export default {
  me: () =>
    makeRequest({
      url: '/api/v1/users/me',
      requestId: 'get-me',
    }),

  fetchAccountUsers: function (accountId) {
    return makeRequest({
      url: '/api/v1/users',
      requestId: 'load-account-users',
    })
  },

  enablePublishing: function (path, userIds = []) {
    const data = {
      user_ids: userIds,
    }
    return makeRequest({
      url: path,
      method: 'put',
      data,
      requestId: 'put-bulk-enable-publishing',
    })
  },

  disablePublishing: function (path, userIds = []) {
    const data = {
      user_ids: userIds,
    }
    return makeRequest({
      url: path,
      method: 'put',
      data,
      requestId: 'put-bulk-disable-publishing',
    })
  },

  bulkDelete: function (path, userIds = []) {
    const data = {
      user_ids: userIds,
    }
    return makeRequest({
      url: path,
      method: 'delete',
      data: data,
      requestId: 'delete-bulk-delete',
    })
  },

  deleteUser: function (userId) {
    return makeRequest({
      url: `/api/v1/users/${userId}`,
      method: 'delete',
      requestId: 'delete-user',
    })
  },
}
